var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{staticClass:"import-btn pt-2 pb-2",class:{
    'non-secondary': _vm.variant !== 'secondary',
    'outline-primary': _vm.variant === 'outline-primary',
    'text-secondary': _vm.variant === 'text-secondary',
},attrs:{"variant":_vm.variant,"size":"lg","extended":"","tiny":_vm.tiny},on:{"click":_vm.openProfileImportDialog}},[(_vm.logo && _vm.importType == 'cv-file')?_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":['fass', 'file-arrow-up'],"size":"lg"}}):_vm._e(),(_vm.logo && _vm.importType == 'linkedin')?_c('img',{staticClass:"img img-normal",attrs:{"src":_vm.LinkedInLogo}}):_vm._e(),(_vm.logo && _vm.importType == 'linkedin')?_c('img',{staticClass:"img img-reverse",attrs:{"src":_vm.LinkedInReverseLogo}}):_vm._e(),_vm._v("\n\n    "+_vm._s(_vm.$t(
            _vm.importType == 'linkedin'
                ? _vm.onlySourceName
                    ? 'profile.import.importPopup.sourceTypeLinkedIn'
                    : 'profile.import.importBtn'
                : _vm.onlySourceName
                    ? 'profile.import.importPopup.sourceTypeCV'
                    : 'profile.import.importCVBtn'
        ))+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }